/// <reference types="vite/client" />

interface ViteEnv {
  VITE_APP_SERVER_HOST?: string;
  VITE_PORT?: string;
}

const API_BASE_URL =
  (import.meta.env as ViteEnv).VITE_APP_SERVER_HOST ||
  `http://localhost:${(import.meta.env as ViteEnv).VITE_PORT || '30005'}`;
const WS_BASE_URL =
  (import.meta.env as ViteEnv).VITE_APP_SERVER_HOST?.replace('http', 'ws') ||
  `ws://localhost:${(import.meta.env as ViteEnv).VITE_PORT || '30005'}`;

export const config = {
  apiBaseUrl: API_BASE_URL,
  wsBaseUrl: WS_BASE_URL,
  endpoints: {
    auth: `${API_BASE_URL}/api/auth`,
    accounting: `${API_BASE_URL}/api/accounting`,
    documents: `${API_BASE_URL}/api/documents`,
    assistant: `${API_BASE_URL}/api/assistant`,
    banking: `${API_BASE_URL}/api/banking`,
    tasks: `${API_BASE_URL}/api/tasks`,
    vouchers: `${API_BASE_URL}/api/vouchers`,
    customers: `${API_BASE_URL}/api/customers`,
    reports: `${API_BASE_URL}/api/reports`,
    settings: `${API_BASE_URL}/api/settings`,
    chat: `${API_BASE_URL}/api/chat`,
    collaboration: `${API_BASE_URL}/api/collaboration`,
    diaryCategorySet: `${API_BASE_URL}/api/diary/category/set`,
    documentsCategorySet: `${API_BASE_URL}/api/documents/category/set`,
    downloadDocuments: `${API_BASE_URL}/api/documents/download`,
    emailDocuments: `${API_BASE_URL}/api/documents/email`,
    searchMessages: `${API_BASE_URL}/api/search/messages`,
  },
};
